module.exports = __webpack_public_path__ + "media/img/illustrations/icons/shift-time-9b556991e9caf11b24e3b585e1afd4e4.svg";